import { queryOptions } from '@tanstack/react-query';
import { privateClient } from '../axiosClients/axiosClients';

export async function insertUserFilter(payload) {
  try {
    const response = await privateClient.put('/UpdateUserForFilter', {
      ...payload,
    });
    return response.data;
  } catch (error) {
    console.error('Error inserting user filter:', error);
  }
}

export async function getUserSite(params) {
  const response = await privateClient.get('/userSite?userId=' + params.userId);
  return response.data;
}

export function createGetUserSite(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['user-site', params],
    queryFn: () => getUserSite(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
